export interface IEnkCheckboxProps {
  id: string
  label: string
  description?: string
  checked?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export function EnkCheckbox(props: IEnkCheckboxProps) {
  const { label, id, description, checked, onChange } = props

  return (
    <div className="relative flex gap-x-3">
      <div className="flex h-6 items-center">
        <input
          key={id}
          id={id}
          name={id}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
        />
      </div>
      <div className="text-sm leading-6">
        <label htmlFor={id} className="font-medium text-gray-900">
          {label}
        </label>
        <p className="text-gray-500">{description}</p>
      </div>
    </div>
  )
}
